import React, { useEffect, useState } from "react";
import { useTheme } from "../context/ThemeContext";
import { useTranslation } from "react-i18next";
import { usePortfolioStore } from "../store/store";
import Loading from "../components/loading";
import Container from "../components/Container";
import DriveImage from "../components/DriveImage";
import { Link } from "react-router-dom";
export default function Projects() {
  const { colors } = useTheme();
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(true);
  const projects = usePortfolioStore((s) => s.projects || []);
  const fetchProjectsRemote = usePortfolioStore((s) => s.fetchProjectsRemote);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await fetchProjectsRemote();
      setLoading(false);
    };
    loadData();
  }, [fetchProjectsRemote]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Container>
      <div className="py-8">
        {/* Header */}
        <div className="mb-4 lg:mb-8">
          <h2
            className={`text-lg md:text-2xl lg:text-4xl font-bold ${colors.text.primary}`}
          >
            {t("projects.title")}
          </h2>
          <p
            className={`text-[11px] sm:text-xs md:text-sm ${colors.text.secondary} mt-1`}
          >
            {t("projects.description")}
          </p>
        </div>

        {/* Projects Grid */}
        {projects.length === 0 ? (
          <div
            className={`${colors.background.secondary} rounded-lg p-12 text-center`}
          >
            <svg
              className={`mx-auto h-16 w-16 ${colors.text.muted} mb-4`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
              />
            </svg>
            <p className={colors.text.secondary}>No projects found.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
            {projects.map((project) => (
              <Link
                key={project.id}
                to={`/projects/${project.id}`}
                className={`${colors.background.primary} rounded-lg border ${colors.border} overflow-hidden hover:shadow-lg transition-all hover:scale-105`}
              >
                {/* Image */}
                <div className="h-48 overflow-hidden bg-gradient-to-br from-sky-400 to-blue-600">
                  <DriveImage
                    src={project.projectsImageUrl}
                    alt={project.name}
                    className="w-full h-full object-cover"
                    fallback={
                      <div className="w-full h-full flex items-center justify-center">
                        <svg
                          className="w-20 h-20 text-white opacity-50"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={1.5}
                            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                          />
                        </svg>
                      </div>
                    }
                  />
                </div>

                {/* Content */}
                <div className="p-3 md:p-5 lg:p-6">
                  <h3
                    className={`text-sm sm:text-base md:text-xl font-semibold mb-2 ${colors.text.primary}`}
                  >
                    {project.name}
                  </h3>
                  <p
                    className={`${colors.text.secondary} text-[11px] sm:text-xs md:text-sm line-clamp-3`}
                  >
                    {project.description || "No description available."}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Container>
  );
}
